import { ProductItemTypes } from '../enums';
import { ProductItemPaginationModel } from '../models';
import { axiosSecure, handleError, handleResponse, RequestResponse } from './config';

export const getProductItems = async (pagination: ProductItemPaginationModel, type: ProductItemTypes, userEntrieOnly: boolean = false, includeNonPurchasable: boolean = false): Promise<RequestResponse> => {
   return await axiosSecure
      .get(`/products/items?page=${pagination.page}&limit=${pagination.limit}&status=${pagination.status ?? ''}&type=${type ?? ''}&orderBy=${''}&userEntriesOnly=${userEntrieOnly}&includeNonPurchasable=${includeNonPurchasable}`)
      .then((response) => handleResponse(response))
      .catch(handleError);
};
